import { CHECKLIST_ITEM_TYPE } from 'src/constants/tasksV2';

export default {
    id: 26,
    type: CHECKLIST_ITEM_TYPE.YES_NO_TOGGLE,
    manifestKey: 'YES_NO_TOGGLE',

    try_it: {
        button_label: 'Toggle Yes / No',
        // Structured-data types fall through to ConfirmationCell (default) in the switch — no dedicated cell exists yet.
        cell_component_import: {
            from: 'src/pages/dashboard/tables/AllLeadTable/TaskChecklistField',
            named: 'ConfirmationCell',
        },
        prefill: {
            completion_state: 'YES',
            response_payload: { value: 'yes' },
        },
    },
    pre_flight_diff: [
        '⚠ value will NOT persist — known bug (BE-#273-cleanup)',
        'PATCH /checklist/{iid}/ with value="yes" or "no" → 200 but value silently dropped',
        'value field not in ChecklistItem model, not in ChecklistItemSerializer.Meta.fields',
        'Checklist item: PENDING → YES (via complete POST only)',
        'TaskActivity row created with action CHECKLIST_ITEM_COMPLETED',
    ],
    has_step2_throttle: false,
    validation_laboratory: [
        {
            label: 'PATCH value="yes" (silent-drop)',
            body: { value: 'yes' },
            expected: '200 but value not persisted — GET confirms field absent (silent drop bug)',
        },
        {
            label: 'PATCH value="no" (silent-drop)',
            body: { value: 'no' },
            expected: '200 but value not persisted — same bug regardless of value',
        },
    ],
};
